module.exports = "/_next/static/images/award-AON-e9e83fc14a0a0d3e35aa0a8b385f8eff.png";